import { ArticleParagraph1, Button, ModalWindow } from '@cian/ui-kit';
import * as React from 'react';

import { BookingDetails, IDetail } from '../NewbuildingFlatBooking';
import * as styles from './NewbuildingBookingModal.css';

export interface INewbuildingBookingModalProps {
  details?: IDetail[] | null;
  error?: boolean;
  loading?: boolean;
  onClose(): void;
  onConfirm(): void;
  open: boolean;
}

export const NewbuildingBookingModal: React.FC<INewbuildingBookingModalProps> = ({
  details,
  error,
  loading,
  onClose,
  onConfirm,
  open,
}) => {
  return (
    <ModalWindow title="Бронирование квартиры" width={688} open={open} onClose={onClose}>
      <div className={styles['container']}>
        <ArticleParagraph1>
          Вы переходите на страницу партнёра Циан: пока не отправите заявку,
          <br />
          вы ни за что не платите
        </ArticleParagraph1>

        {details && details.length > 0 && (
          <div className={styles['content-block']}>
            <BookingDetails details={details} />
          </div>
        )}

        <div className={styles['buttons-container']}>
          <div className={styles['button']}>
            <Button theme="fill_primary" size="XS" onClick={onConfirm} loading={loading} type="button" fullWidth>
              Продолжить
            </Button>
          </div>
          <div className={styles['button']}>
            <Button theme="fill_white_primary" size="XS" onClick={onClose} disabled={loading} type="button" fullWidth>
              Отменить
            </Button>
          </div>
        </div>

        {error && (
          <div className={styles['content-block']}>
            <ArticleParagraph1 color="error_100">Возникла ошибка. Попробуйте еще раз</ArticleParagraph1>
          </div>
        )}
      </div>
    </ModalWindow>
  );
};
